const TTL_MS = 60_000;

type ModelRow = {
  id: number;
  name: string;
  topic?: string | null;
  image_url?: string | null;
  video_url?: string | null;
  has_video?: boolean | null;
  discount_text?: string | null;
  is_online?: boolean | null;
  is_active?: boolean | null;
  badges?: string[] | null;
  filters?: any;
  filter_age?: string | null;
  filter_appearance?: string | null;
  filter_origin?: string | null;
  filter_style?: string | null;
  is_ad?: boolean | null;
  external_url?: string | null;
  outbound_url?: string | null;
  internal_route?: string | null;
  ad_format?: '1x1' | '1x2' | 'full' | null;
  views?: number | null;
};

let _models: { at: number; rows: ModelRow[]; onlineUsersCount: number } | null = null;
let _favorites: { at: number; ids: Set<number> } | null = null;

export function getCachedModels(): { rows: ModelRow[]; onlineUsersCount: number } | null {
  if (!_models || Date.now() - _models.at > TTL_MS || !_models.rows.length) return null;
  return { rows: _models.rows, onlineUsersCount: _models.onlineUsersCount };
}

export function setCachedModels(rows: ModelRow[], onlineUsersCount: number): void {
  _models = { at: Date.now(), rows, onlineUsersCount };
}

export function clearCachedModels(): void {
  _models = null;
}

export function getCachedFavorites(): Set<number> | null {
  if (!_favorites || Date.now() - _favorites.at > TTL_MS) return null;
  return _favorites.ids;
}

export function setCachedFavorites(ids: Set<number>): void {
  _favorites = { at: Date.now(), ids };
}
